let varTheme = {}

varTheme['master'] = require("./var").default;
varTheme['tsl'] = require("./varTsl").default;
varTheme['use'] = require("./varUse").default;

export default varTheme